import React, { forwardRef, HTMLAttributes, ReactNode, Ref } from "react";

import {
    DropdownButton,
    DropdownIcon,
    SelectTabButton,
    StyledTab,
} from "./F3.HomeTabs.styles";
import { F3TabIcon } from "./F3.TabIcon";

export interface ITabItemProps {
    children: ReactNode;
    icon: string;
    isSaving?: boolean;
    isSelected?: boolean;
    isDragging?: boolean;
    isFloating?: boolean;
    filtering?: boolean;
    dropdownRef?: Ref<HTMLButtonElement>;
    onSelect?: () => void;
    onOpenDropdown?: () => void;
}

export const TabItem = forwardRef<
    HTMLDivElement,
    ITabItemProps & HTMLAttributes<HTMLDivElement>
>(function TabItem(props, ref) {
    const {
        isSaving = false,
        isSelected = false,
        isDragging = false,
        isFloating = false,
        filtering = false,
        onSelect,
        icon,
        children,
        onOpenDropdown,
        dropdownRef,
        ...divProps
    } = props;
    return (
        <StyledTab
            ref={ref}
            {...divProps}
            $selected={isSelected}
            $dragging={isDragging}
            $filtering={filtering}
            title={isSaving ? "Saving…" : undefined}
            data-testid={`tab-item-${children}`}
        >
            <SelectTabButton
                $saving={isSaving}
                $floating={isFloating}
                onClick={onSelect}
            >
                <F3TabIcon icon={icon} />
                {children}
            </SelectTabButton>
            {isSelected && onOpenDropdown && (
                <DropdownButton
                    ref={dropdownRef}
                    onClick={onOpenDropdown}
                    data-testid="selected-tab-dropdown-button"
                >
                    <DropdownIcon name="dropdown-arrow" size="18" />
                </DropdownButton>
            )}
        </StyledTab>
    );
});
